export default "__VITE_ASSET__Dg0E6q3m__"